/**
 * 인워드브랜딩 시절 BlocksCarousel 의 자리 표시 stub.
 * - admin/work/WorkCanvasPreviewPanel.ts 가 import 하고 있어 빌드를 보호하려고 유지.
 * - PICHI 공개 사이트에선 사용처가 없어 noop. 추후 admin 캔버스에서 캐러셀 미리보기가 필요해지면 실제 구현 채움.
 */
export function initBlocksCarousel(): void {
    /* noop */
}
